import { FormatExternalPaymentMethodFormForSubmissionUseCase } from './FormatExternalPaymentMethodFormForSubmissionUseCase'

export const formatExternalPaymentMethodFormForSubmissionUseCase =
  new FormatExternalPaymentMethodFormForSubmissionUseCase().execute
